import fetchHandler, { fetchHandlerForm } from './Handler';

export const OureventsPOst = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: 'admin/ourevents',
			data,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const OureventsGET = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/ourevents', // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching orders:', error); // Corrected error message
		throw new Error('Could not fetch orders. Please try again later.'); // Corrected error message
	}
};

export const deleteOurevents = async (data: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/ourevents/${data}`, // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error deleting order:', error); // Corrected error message
		throw new Error('Could not delete order. Please try again later.'); // Corrected error message
	}
};

// =======================================================
export const updateOurevents = async (body: any, id: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/ourevents/${id}`,
			data: body,
		});
		return response;
	} catch (error) {
		console.error('Error updating order:', error); // Corrected error message
		throw new Error('Could not update order. Please try again later.'); // Corrected error message
	}
};

export const updateEnquiresStatus = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `contactus/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error updating order status:', error); // Corrected error message
		throw new Error('Could not update order status. Please try again later.'); // Corrected error message
	}
};

export const getSingleEnquires = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `contactus/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching order:', error); // Corrected error message
		throw new Error('Could not fetch order. Please try again later.'); // Corrected error message
	}
};
